import { render } from "./OttoHzys.vue?vue&type=template&id=1a593ed9&scoped=true"
import script from "./OttoHzys.vue?vue&type=script&lang=js"
export * from "./OttoHzys.vue?vue&type=script&lang=js"

import "./OttoHzys.vue?vue&type=style&index=0&id=1a593ed9&scoped=true&lang=css"
import "./OttoHzys.vue?vue&type=style&index=1&id=1a593ed9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a593ed9"]])

export default __exports__